import React from 'react'

/**
 * Formats a date value for display in a grid cell.
 * @param {Object} rowData - The row data object
 * @param {string} field - The field name to format
 * @returns {string} Formatted date string in dd/mm/yyyy format
 */
const DateBodyTemplate = ({ rowData, field }) => {
    const dateValue = field ? rowData[field] : rowData.date
    
    // Return empty string if no date value
    if (!dateValue) return ''
    
    // Convert string to Date object if needed
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue)
    
    // Check if the date is valid
    if (isNaN(date.getTime())) return ''
    
    return date.toLocaleDateString('en-GB', {
        timeZone: 'UTC',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })
}

export default DateBodyTemplate
